const initialState = {
  status: "disconnected"
};

export default function signalrReducer(state = initialState, action) {
  switch (action.type) {
    case 'SET_CONN_SIGNALR':
      return {
        ...state,
        status: action?.payload,
      }
    default:
      return state
  }
}
